export default class Score {
    static preload(scene){
        scene.load.image('score', 'src/assets/img/score_text2.png');
    }

    constructor({scene}){
        this.scene = scene;

        this.container = this.scene.rexUI.add.sizer({
            orientation: "y",
            anchor: "center",
            x:400,
            y:60
        });

        this.scoreTextImg = scene.add.image(0, 0, "score");
        this.scoreTextImg.setScale(0.6);

        this.scoreSizer = this.scene.rexUI.add.overlapSizer({
            // x: 0,
            // y: 0,
            // anchor: undefined,
            // width: undefined,
            // height: undefined,
            // space: { left: 0, right:0, top:0, bottom:0 },

            // name: '',
            // draggable: false,
            // sizerEvents: false,
            // enableLayer: false,
        });

        this.scoreTextBehind = this.scene.add.text(0, 0, '0',
            {
                fill: "#000",
                fontSize: "45px",
                fontFamily: "Splurge"
            });
        this.scoreText = this.scene.add.text(0, 0, '0',
            {
                fill: "#188741",
                fontSize: "40px",
                fontFamily: "Splurge"
            });

        this.scoreSizer.add(this.scoreTextBehind, {align: "center"});
        this.scoreSizer.add(this.scoreText, {align: "center"});

        this.scoreSizer.layout();

        this.container.add(this.scoreTextImg);
        this.container.add(this.scoreSizer);
        this.container.layout();
    }

    changeScore(score){
        this.scoreText.setText(score);
        this.scoreTextBehind.setText(score);
    }
}